const MuiDialogActions = {
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
}

export default MuiDialogActions
